module.exports = __webpack_public_path__ + "assets/Lambda.eeb3f12a1aac4aad0649a0be9fa9eb58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs2x/Lambda.png
// module id = 837
// module chunks = 0